
import '../styles/BlogStyles/BlogStyles.css';
import { Link } from 'react-router-dom';
import blog from "../assets/blog.jpeg";
import bloglist from "../assets/blog1.jpeg";

const BlogList = () => {
  return (
    <div className="blog-page-wrapper">
      
      {/* 1. Hero Section with Laptop Image */}
      <section className="blog-hero position-relative">
        <img 
          src={blog}
          alt="Blog Header Laptop" 
          className="w-100 img-fluid blog-hero-img"
        />
      {/*   <div className="blog-hero-overlay d-flex align-items-center justify-content-center">
          <h1 className="display-3 fw-bold text-white text-uppercase">Blog</h1>
        </div> */}
      </section>

      {/* 2. Blog Post Grid */}
      <section className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-4">
            
            {/* Blog Card */}
            <div className="card h-100 shadow-sm border-0 blog-card">
              <div className="overflow-hidden rounded-top">
                <img 
                  src={bloglist} 
                  alt="Classroom" 
                  className="card-img-top blog-card-img"
                />
              </div>
              <div className="card-body p-4">
                <h5 className="card-title fw-bold text-dark mb-3">
                Strong Foundation, Bright Future – School Tuitions at Madhi Academy
                </h5>
                <p className="card-text text-muted small mb-4 line-clamp-3">
                Best School Tuitions in Chennai | CBSE & State Board – Madhi Academy Every child deserves the right guidance to...
                </p>
                {/* Navigation Link to the Detail Page */}
                <Link to="/blog/indian-vs-global-certifications" className="btn btn-purple px-4 py-2">
                  Read More
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default BlogList;